import { useCallbackRef } from "./auth-service-tools566.js";
import { useIsomorphicEffect } from "./auth-service-tools217.js";

function useResizeObserver(element, onResize) {
  const handleResize = useCallbackRef(onResize);
  useIsomorphicEffect(() => {
    let rAF = 0;

    if (element) {
      const resizeObserver = new ResizeObserver(() => {
        cancelAnimationFrame(rAF);
        rAF = window.requestAnimationFrame(handleResize);
      });
      resizeObserver.observe(element);
      return () => {
        window.cancelAnimationFrame(rAF);
        resizeObserver.unobserve(element);
      };
    }

    return void 0;
  }, [element, handleResize]);
}

export { useResizeObserver };